import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_toad-factory/artifacts/0sl21so2_1778465183515.png";

const NAV = [
  { label: "WORK", href: "#work" },
  { label: "SERVICES", href: "#services" },
  { label: "PROCESS", href: "#process" },
  { label: "QUOTE", href: "#quote" },
  { label: "CONTACT", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 border-b border-[#2A2A2A] transition-colors ${
        scrolled ? "bg-[#0A0A0A]/90 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link">
          <span className="logo-tile p-1">
            <img
              src={LOGO_URL}
              alt="Forge State 3D Manufacturing"
              className="h-10 md:h-12 w-auto"
            />
          </span>
          <span className="font-mono-ui text-[10px] tracking-[0.3em] text-white/50 hidden md:block border-l border-[#2A2A2A] pl-3 leading-tight">
            FORGE STATE<br />3D MFG · LLC
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="font-mono-ui text-[11px] tracking-[0.25em] text-white/70 hover:text-[#FF5722] transition-colors"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
          <a
            href="#quote"
            className="font-mono-ui text-[11px] tracking-[0.25em] uppercase font-bold bg-[#FF5722] text-white px-5 py-2.5 hover:bg-white hover:text-black transition-colors"
            data-testid="header-cta-quote"
          >
            Get a Quote →
          </a>
        </nav>

        <button
          aria-label="Menu"
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#2A2A2A] bg-[#0A0A0A]" data-testid="mobile-nav">
          <div className="flex flex-col px-6 py-6 gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="font-mono-ui text-sm tracking-[0.25em] text-white/80"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              className="font-mono-ui text-sm tracking-[0.2em] bg-[#FF5722] text-white px-4 py-3 text-center"
            >
              GET A QUOTE
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
